"use client";

import React from "react";
import styled from "styled-components";

import { positioningCSS } from "../utils";
import { markdownStyle } from "../../constants/markdownStyle";
import { ElementPositioningProps } from "../ComponentProps";
import renderMarkdown from "../../helpers/renderMarkdown";
import useIsClient from "../../hooks/useIsClient";

type Props = {
  font?: string; // default "gallery.regular"
  elements?: "basic" | "gallery";
  color?: string;
  children: React.ReactNode;
} & ElementPositioningProps & { className?: string };

const Wrapper = styled.div<ElementPositioningProps & { font: string; color: string }>`
  word-break: break-word;
  flex: 1 1 100%;
  ${positioningCSS}
  ${markdownStyle}
`;

const MarkdownText: React.FC<Props> = ({ children, elements, ...rest }) => {
  const isClient = useIsClient();
  if (typeof children !== "string") return null;
  if (!isClient) return null;

  const html = renderMarkdown(children, { elements });

  return (
    <Wrapper
      font="gallery.regular"
      color="black"
      {...rest}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default MarkdownText;
